import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../../layouts/PageLayout";
import { PageHeader } from "../../../components/v3";
import { AddEditMaterial, MaterialList } from "../../../components/library";
import { useHasPermission } from "../../../utils";
import { CREATE_MATERIAL } from "../../../constants";

export const Materials = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasCreateMaterial = useHasPermission(CREATE_MATERIAL);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasCreateMaterial && {
      buttonText: "Add Material",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader title="Materials" subtitle={`${totalCount} Materials`} buttons={buttons} />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <MaterialList totalCount={totalCount} setTotalCount={setTotalCount} onSuccess={handleReload} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add material modal */}
      <AddEditMaterial open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
